import { ChevronDownIcon } from '@heroicons/react/24/outline/index.js';
import { google, ics, outlook, yahoo } from 'calendar-link';
import AppleIcon from '../../components/icons/AppleIcon.jsx';
import GoogleIcon from '../../components/icons/GoogleIcon.jsx';
import OutlookIcon from '../../components/icons/OutlookIcon.jsx';
import YahooIcon from '../../components/icons/YahooIcon.jsx';
import IcsIcon from '../../components/icons/IcsIcon.jsx';
import PopoverButton from '../../components/PopoverButton.jsx';

const AddCalendarButton = ({ icon, title, url, isFirst }) => {
    return (
        <a
            href={url}
            target="_blank"
            className={`${isFirst ? '' : 'mt-3'} no-underline text-black flex items-center justify-between cursor-pointer`}
        >
            <div className={`mr-2 ${!isFirst ? 'pt-3' : ''}`}>{icon}</div>
            <div className={`${!isFirst ? 'border-t pt-3' : ''} flex-1`}>
                {title}
            </div>
        </a>
    );
};

const AddToCalendar = ({ event, confirmationUrl }) => {
    const invite = {
        title: `${event.event_type?.name} (${event.bookable_resource?.name})`,
        start: event.client_start,
        end: event.client_end,
        allDay: event?.event_type?.is_all_day,
        location: event.location,
        description: `${event?.location ? `Location: ${event.location}\n\n` : ''}View or change by visiting ${confirmationUrl}`,
    };

    return (
        <PopoverButton
            btnContent={
                <div className="flex items-center form-button">
                    Add to Calendar
                    <ChevronDownIcon className="w-4 h-4 ml-2" />
                </div>
            }
        >
            {({ close }) => (
                <div>
                    <AddCalendarButton
                        title="Apple"
                        url={ics(invite)}
                        isFirst={true}
                        icon={<AppleIcon />}
                    />
                    <AddCalendarButton
                        title="Google"
                        url={google(invite)}
                        icon={<GoogleIcon />}
                    />
                    <AddCalendarButton
                        title="Outlook"
                        url={outlook(invite)}
                        icon={<OutlookIcon />}
                    />
                    <AddCalendarButton
                        title="Yahoo"
                        url={yahoo(invite)}
                        icon={<YahooIcon />}
                    />
                    <AddCalendarButton
                        title="Download (.ics)"
                        url={ics(invite)}
                        icon={<IcsIcon />}
                    />
                </div>
            )}
        </PopoverButton>
    );
};

export default AddToCalendar;
